import {Injectable} from '@angular/core';
import * as EmployeeModels from '@employee-models/index';
import { DeliveryLocationService } from './static-data/delivery-location-service';
import {RejectReasonsService} from './static-data/reject-reasons.service';


@Injectable({
    providedIn: 'root'
})

export class StaticDataService {

  constructor(private rejectReasonsService: RejectReasonsService, private deliveryLocationService: DeliveryLocationService) {}

  fetchRejectReasons(): void {
    this.rejectReasonsService.fetchRejectReasons();
  }

  getRejectReasons(): EmployeeModels.DM.IRejectedPhotoReasonModel[] {
    return this.rejectReasonsService.rejectReasons;
  }

  fetchDeliveryLocationList(): void {
    this.deliveryLocationService.fetchDeliveryLocations();
  }

  getDeliveryLocationList(): EmployeeModels.DM.IDeliveryLocationDto[] {
    return this.deliveryLocationService.deliveryLocations;
  }


}
